<template>
    <ResourceList addLabel="Add"
                  :addRoute="!hideAddButton ? addRoute : null"
                  :params="params"
                  :query="query"
                  ref="resourceList"
                  :resource="resource"
                  :renderAs="renderAs"
                  title="Bands"
    />
</template>

<script>
import {Band} from '@/internal';
import BandResourceListItem from '@/components/Band/ResourceListItem.vue';

export default {
  name: 'BandResourceList',
  data() {
    return {
      params: {
        include: [],
      },
      resource: Band,
    };
  },
  props: {
    addRoute: {
      default() {
        return window.app.findRouteByName('band/create');
      },
      required: false,
    },
    hideAddButton: {
      default: false,
      type: Boolean,
    },
    query: {
      default: () => {
      },
      required: false,
    },
    renderAs: {
      default: () => {
        return BandResourceListItem;
      },
      required: false,
    },
  },
};
</script>

<style scoped lang="scss">

</style>
